import React, { createContext, useContext, useEffect, useState } from 'react';
import { STORAGE_KEY_CALL911STATUS } from '../constants';
import { useLocalStorage } from './useLocalStorage';

export interface E911CasesContextProps {
  call911Status: string;
  setCall911Status: React.Dispatch<React.SetStateAction<string>>;
  isLocationValidated: boolean;
  setIsLocationValidated: React.Dispatch<React.SetStateAction<boolean>>;
  isAuthKeyValidated: boolean;
  setIsAuthKeyValidated: React.Dispatch<React.SetStateAction<boolean>>;
  saveCall911Status: (call911StatusInput: string) => void;
}

export const E911CasesContext = createContext<E911CasesContextProps | null>(
  null,
);

export const E911CasesProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { withLocalStorage } = useLocalStorage();

  const [call911Status, setCall911Status] = useState<string>('INACTIVE');
  const [isLocationValidated, setIsLocationValidated] =
    useState<boolean>(false);

  const [isAuthKeyValidated, setIsAuthKeyValidated] = useState<boolean>(false);

  useEffect(() => {
    const call911StatusInput = withLocalStorage(STORAGE_KEY_CALL911STATUS);
    setCall911Status(call911StatusInput ? call911StatusInput : call911Status);
  }, [call911Status, withLocalStorage]);

  const saveCall911Status = (call911StatusInput: string) => {
    setCall911Status(call911StatusInput);
    withLocalStorage(STORAGE_KEY_CALL911STATUS, call911StatusInput);
  };

  return (
    <E911CasesContext.Provider
      value={{
        call911Status,
        setCall911Status,
        isLocationValidated,
        setIsLocationValidated,
        isAuthKeyValidated,
        setIsAuthKeyValidated,
        saveCall911Status,
      }}
    >
      {children}
    </E911CasesContext.Provider>
  );
};

export function useE911Cases(): E911CasesContextProps {
  const context = useContext(E911CasesContext);
  return context || assertNever();
}

function assertNever(): never {
  throw Error('Cannot use useE911Cases outside of E911CasesProvider');
}
